// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"30bc25d0","977":"d1e0aa68"}[chunkId] + ".chunk.js";
};